module.exports = __webpack_public_path__ + "static/icons/icon-user--red-c2c3b3000d5bcfa23e651d3e1c47cd37.svg";